export default __webpack_public_path__ + "static/media/ClearviewMarketSquare.d5a0e113.jpg";